import { render, staticRenderFns } from "./LiquidationSellerLiquidated.vue?vue&type=template&id=5c864391&"
import script from "./LiquidationSellerLiquidated.vue?vue&type=script&lang=js&"
export * from "./LiquidationSellerLiquidated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports